import React from 'react';
import Console from './components/Console';

function App() {
  return <Console />;
}

export default App;